export { Home as default } from './Home'
export { default as FeaturedArticles } from './FeaturedArticles/FeaturedArticles'
export { default as FeaturedProjects } from './FeaturedProjects/FeaturedProjects'
export { default as HeroBanner } from './HeroBanner/HeroBanner'
export { default as OurServices } from './OurServices/OurServices'
export { default as OurValues } from './OurValues/OurValues'
export { default as Testimonials } from './Testimonials/Testimonials'
